import { IsArray, IsNotEmpty, ValidateNested, IsObject } from 'class-validator';
import { Type } from 'class-transformer';

import { EmployeeTimezoneExceptionDto } from './employee-timezone-exception.dto';
import { NotificationMessagesDto } from './notification-messages.dto';

export class RemoveEmployeeFromExceptionsDto {
  @IsArray()
  @IsNotEmpty()
  @ValidateNested({ each: true })
  employees: EmployeeTimezoneExceptionDto[];

  @IsObject()
  @IsNotEmpty()
  @ValidateNested()
  @Type(() => NotificationMessagesDto)
  notificationMessages: NotificationMessagesDto;
}
